import type { CardProps } from '@zillow/constellation';
import { Heading, Text } from '@zillow/constellation';
import omit from 'lodash/omit';
import type { PropsWithChildren, ReactElement } from 'react';
import React from 'react';
import * as S from './styles';

interface DataCardProps {
    heading: string | ReactElement;
    copyText: string | ReactElement;
    source?: string;
    useFullScreen: boolean;
    height?: number;
}

const DataCard: React.FunctionComponent<PropsWithChildren<DataCardProps & CardProps>> = (props) => {
    const { heading, copyText, source } = props;
    const rest = omit(props, ['children', 'heading', 'copyText', 'source']);
    return (
        <S.Card cardType="secondary" padding="md" paddingBottom={source ? 'xl' : 'md'} {...rest}>
            <Heading level="4" as="h2" fontFamily="serif">
                {heading}
            </Heading>
            <Text as="p" fontType="bodySmall" fontColor="textMedium" marginBottom="md">
                {copyText}
            </Text>

            {props.children}
            {source && (
                <Text
                    as="p"
                    fontType="bodySmall"
                    fontColor="textMedium"
                    style={{ position: 'absolute', bottom: '16px' }}
                >
                    Source: {source}
                </Text>
            )}
        </S.Card>
    );
};

export default DataCard;
